module.exports = __webpack_public_path__ + "img/Table-consent.1a9a147f.svg";